export default __webpack_public_path__ + "static/media/Abundant_Thinking_16_9.8ade95d3.png";